<div class="card p-4 d-flex flex-column mt-2">
  <nz-skeleton
    [ngClass]="loading ? 'p-3' : 'p-0'"
    [nzLoading]="loading"
    [nzActive]="true"
  >
    <div class="py-1 title">Team’s List</div>
    <div class="d-flex mt-4 flex-column">
      <div class="d-flex flex-md-column flex-lg-row justify-content-between">
        <div class="col-8 d-flex flex-column">
          <h6 class="text-bold">Manage your team with ease.</h6>
          <span
            >View and organize all team members under your main account. Add,
            edit, or remove users to collaborate and manage your operations
            better.</span
          >
        </div>
        <div class="col-4 d-flex justify-content-md-start justify-content-lg-end align-items-center">
          <button class="btn btn-outline-primary" (click)="addTeam()">Add Team</button>
        </div>
      </div>
    </div>
    <div>
      <nz-table
        #fixedTable
        [nzData]="listOfData"
        class="mt-4"
        [nzSize]="'middle'"
        [nzShowPagination]="false"
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>Role</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (data of fixedTable.data; track data) {
          <tr>
            <td>
              <div class="d-flex gap-3 align-items-center align-content-center">
                <img
                  src="https://storage.googleapis.com/komerce/assets/icons/profile-placehold.svg"
                  class="main-profile-img rounded-circle"
                  style="width: 35px; cursor: pointer; height: 35px"
                  alt="profile"
                />
                <span class="d-flex flex-column">
                  <span>
                    {{ data.name }}
                  </span>
                  <span class="text-secondary">
                    {{ data.email }}
                  </span>
                </span>
              </div>
            </td>
            <td>{{ data.role }}</td>
            <td>
              <span [ngClass]="getClassStatus(data.status)" class="px-4 py-2 rounded-pill">
                {{ data.status }}
              </span>
            </td>
            <td>
              <div class="d-flex gap-2">
                <button class="btn p-0" (click)="editTeam(data.id)">
                  <img src="https://storage.googleapis.com/komerce/assets/icons/edit.svg" alt="edit">
                </button>
                <button class="btn p-0" (click)="changeStatus(data.id, data.status)">
                  <img src="https://storage.googleapis.com/komerce/assets/icons/key-reset.svg" alt="activate">
                </button>
                <button class="btn p-0" (click)="deleteTeam(data.id)">
                  <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/trash.svg" alt="delete">
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </nz-table>
    </div>
  </nz-skeleton>
</div>

<app-delete-team [idTeam]="idTeam" [isShowConfirm]="showDelete" (isShowConfirmEvent)="successDelete()" />
